import { Model } from '../sharedBetweenServerAndClient__DO_NOT_EDIT/types'

export const getCanManuallyShowHand = (gameHand: Model.GameHand, selectedUserId: string) => {
  const { finalResult } = gameHand
  if (!finalResult) {
    return false
  }
  if (finalResult.automaticallyVisibleUserHands.some(({ userId }) => userId === selectedUserId)) {
    return false
  }
  if (!finalResult.manuallyVisibleUserHands) {
    return true
  }
  return finalResult.manuallyVisibleUserHands.every(({ userId }) => userId !== selectedUserId)
}
